// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__33wq-","header":"PatientQuestionnaire_header__3x3gJ","info":"PatientQuestionnaire_info__3S4jL"};